import axiosService from '@services/axiosService';

export const getCountriesList = (token) =>
  axiosService.get('/api/TwilioNumbers', {
    params: {
      access_token: token,
      filter: { order: 'country' },
    },
  });



// WEBPACK FOOTER //
// ./services/countriesResource.js